import SignIn from './SignIn'
import NotFound from './NotFound'
import ForgotPassword from './ForgotPassword'
import SignUp from './SignUp'

const sessionRoutes = [
    {
        path: '/signin',
        component: SignIn,
    },
    {
        path: '/forgot-password',
        component: ForgotPassword,
    },
    {
        path: '/404',
        component: NotFound,
    },
    {
        path: '/signup/:token',
        exact: true,
        component: SignUp,
    }
]

export default sessionRoutes
